document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faq-categories__item");

  faqItems.forEach((item) => {
    const button = item.querySelector(".faq-categories__question");
    const answer = item.querySelector(".faq-categories__answer");
    const icon = item.querySelector(".faq-categories__icon");

    button.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Close all other items
      faqItems.forEach((el) => {
        const elAnswer = el.querySelector(".faq-categories__answer");
        el.classList.remove("active");
        elAnswer.style.maxHeight = null;
      });

      // Open current item
      if (!isActive) {
        item.classList.add("active");

        const scrollHeight = answer.scrollHeight;
        answer.style.maxHeight = scrollHeight + "px";
      }
    });
  });

  const categoryButtons = document.querySelectorAll(
    ".faq-categories__category-button",
  );
  const mobileScrollContainer = document.querySelector(
    ".faq-categories__mobile-scroll",
  );

  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.dataset.target;

      categoryButtons.forEach((btn) => btn.classList.remove("active"));
      const matchingButtons = document.querySelectorAll(
        `.faq-categories__category-button[data-target="${targetId}"]`,
      );
      matchingButtons.forEach((btn) => btn.classList.add("active"));

      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const headerOffset = 110;
        const offsetPosition =
          targetElement.getBoundingClientRect().top +
          window.scrollY -
          headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }

      // Auto scroll mobile tabs
      if (
        mobileScrollContainer &&
        button.closest(".faq-categories__mobile-scroll")
      ) {
        setTimeout(() => {
          const containerRect = mobileScrollContainer.getBoundingClientRect();
          const buttonRect = button.getBoundingClientRect();
          const newScrollLeft =
            mobileScrollContainer.scrollLeft +
            (buttonRect.left - containerRect.left) -
            30;

          mobileScrollContainer.scrollTo({
            left: newScrollLeft,
            behavior: "smooth",
          });
        }, 150);
      }
    });
  });

  // Set first category active
  if (categoryButtons.length > 0) {
    const firstTarget = categoryButtons[0].dataset.target;
    document
      .querySelectorAll(
        `.faq-categories__category-button[data-target="${firstTarget}"]`,
      )
      .forEach((btn) => btn.classList.add("active"));
  }
});
